(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["khairat-cart-bar"] && !Shopify.designMode) return;
  try {
    (() => {
  const bar = document.getElementById('kf-cart-bar');
  if (!bar || bar.dataset.ready) return;
  bar.dataset.ready = 'true';
  const space = document.getElementById('kf-cart-space');
  const count = bar.querySelector('[data-kf-count]');
  const total = bar.querySelector('[data-kf-total]');
  const mobile = window.matchMedia('(max-width: 749px)');
  let timer;
  let busy = false;
  let again = false;
  let revision = 0;

  const queue = () => {
    revision++;
    clearTimeout(timer);
    timer = setTimeout(refresh, 150);
  };

  async function refresh() {
    if (!mobile.matches || document.hidden) return;
    if (busy) { again = true; return; }
    busy = true;
    const current = revision;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const response = await fetch(bar.dataset.cartUrl, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: controller.signal
      });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (current !== revision) { again = true; return; }
      if (!Number.isFinite(cart.item_count) || !Number.isFinite(cart.total_price)) {
        throw new Error('Invalid cart');
      }
      count.textContent = String(cart.item_count);
      total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: cart.currency
      }).format(cart.total_price / 100);
      bar.hidden = space.hidden = cart.item_count === 0;
    } catch {
      bar.hidden = space.hidden = true;
    } finally {
      clearTimeout(timeout);
      busy = false;
      if (again) { again = false; queue(); }
    }
  }

  bar.addEventListener('click', event => {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) {
      event.preventDefault();
      trigger.click();
    }
  });

  document.addEventListener('cart:update', queue);
  window.addEventListener('pageshow', queue);
  window.addEventListener('focus', queue);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) queue();
  });
  mobile.addEventListener('change', queue);

  if ('PerformanceObserver' in window) {
    const observer = new PerformanceObserver(list => {
      if (list.getEntries().some(entry => {
        const url = new URL(entry.name, location.href);
        return url.origin === location.origin &&
          /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
      })) queue();
    });
    observer.observe({ type: 'resource', buffered: false });
  }
  const bubble = document.querySelector('cart-icon');
  if (bubble) {
    new MutationObserver(queue).observe(bubble, {
      childList: true, subtree: true, characterData: true
    });
  }
  queue();
})();
  } catch(e) { console.error(e); }
})();

})();
